import { $authHost } from '..';

export default class CartCategoryes {
  static addCategoryes(id: any) {
    return $authHost.get(`/categories/${id}`);
  }
}
